export const addZeroes = (num: number) => (num / 100).toFixed(2)
